import { useEffect, useRef, useState } from "react";
import { api, SITE_HOST } from "../api";
import { Logo } from "../components/Logo";
import { Footer } from "../components/Footer";

type State = { kind: "verifying" } | { kind: "ok" } | { kind: "error" };

export function Verify({
  token,
  onVerified,
}: {
  token: string;
  onVerified: (me: { id: string; email: string }) => void;
}) {
  const [state, setState] = useState<State>({ kind: "verifying" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api
      .verifyEmail(token)
      .then((me) => {
        setState({ kind: "ok" });
        setTimeout(() => onVerified(me), 600);
      })
      .catch(() => setState({ kind: "error" }));
  }, [token, onVerified]);

  return (
    <>
      <div className="login-shell">
        <div className="login-card" style={{ textAlign: "center" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
            <Logo size={48} withDot={state.kind === "ok"} title={SITE_HOST} />
          </div>
          {state.kind === "verifying" && <div className="muted">E-posta doğrulanıyor…</div>}
          {state.kind === "ok" && <div>Doğrulandı! Portala yönlendiriliyorsunuz…</div>}
          {state.kind === "error" && (
            <>
              <div className="error">Bağlantı geçersiz veya süresi dolmuş.</div>
              <div style={{ marginTop: 16 }}>
                <a href="/">Giriş sayfasına dön</a>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
